import { State } from '../machine';

export enum Section {
  CompanyInformation = 'companyInformation',
  SupportingDocuments = 'supportingDocuments',
  Plan = 'plan',
  Review = 'review',
}

export const STATE_TO_SECTION: Record<State, Section | null> = {
  [State.INIT]: null,
  [State.ABORT]: null,
  [State.DONE]: null,

  [State.ABORT_APPLICATION]: null,

  [State.ELIGIBILITY]: null,

  [State.PERSONAL_INFO]: Section.CompanyInformation,
  [State.COMPANY_COMPLIANCE]: Section.CompanyInformation,
  [State.BUSINESS_INFO_FORM]: Section.CompanyInformation,
  [State.BUSINESS_INFO_REFUSED]: Section.CompanyInformation,
  [State.BUSINESS_INFO_COMPLETE]: Section.CompanyInformation,

  [State.VERIFICATION]: Section.SupportingDocuments,
  [State.USER_AGREEMENT]: Section.SupportingDocuments,

  [State.PLAN_CHOICE]: Section.Plan,
  [State.SUBMIT_APPLICATION]: Section.Plan,

  [State.NEXT_STEPS]: Section.Review,
};

export const SECTIONS = [
  Section.CompanyInformation,
  Section.SupportingDocuments,
  Section.Plan,
  Section.Review,
] as const;
